import Logo from "shared/Logo/Logo";
import SocialsList1 from "shared/SocialsList1/SocialsList1";
import { FooterLink } from "data/types";
import React from "react";
import { globalJson } from "global/global_json";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: FooterLink[];
}

const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "5",
    title: "Explore",
    menus: [
      {
        href: "/privacy-policy",
        label: (
          <>
            Privacy Policy
            <br />
            Terms & Conditions
          </>
        ),
      },
      { href: "/terms-conditions", label: "Cancellation Policy" },
      { href: "/Rental-Agreement", label: "Rental Agreement" },
      { href: "/requirements", label: "Requirements" },
      { href: "/FAQ", label: "FAQ" },
    ],
  },
  {
    id: "2",
    title: "Link",
    menus: [
      { href: "/about", label: "About Us" },
      { href: "/vehicles", label: "Our Fleet" },
      { href: "/contact", label: "Contact Us" },
    ],
  },
  {
    id: "1",
    title: "Contact Us",
    menus: [
      { label: globalJson.operating_time },
      { label: globalJson.phone },
      { label: globalJson.email },
      { label: globalJson.address },
    ],
  },
];

const Footer: React.FC = () => {
  const formatAddress = (address: string): JSX.Element => {
    const regex = /,/g; // Split by commas only
    const lines = address.split(regex).map((line) => line.trim());
  
    return (
      <div className="address-container">
        {lines.map((line, index) => {
          if (line.includes("Suite") || line.includes("Wilmington") || line.includes("DE")) {
            // Combine "Suite", "Wilmington", and "DE" into one line
            const nextLine = lines[index + 1];
            const thirdLine = lines[index + 2];
            if (nextLine?.includes("Wilmington") || thirdLine?.includes("DE")) {
              return (
                <div key={index} className="address-line">
                  {line}, {nextLine} {thirdLine}
                </div>
              );
            }
          }
          return (
            <div key={index} className="address-line">
              {line}
            </div>
          );
        })}
      </div>
    );
  };
  

  const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
    return (
      <div key={index} className="text-sm  sm:ml-0">
        <h2 className="font-bold text-white dark:text-neutral-200 ">
          {menu.title}
        </h2>
        <ul className="mt-5 space-y-4">
          {menu.menus.map((item, index) => (
            <li key={index} className="flex items-start gap-3 break-all">
              {item.href ? (
                <a
                  className="text-[#8A99B4] dark:text-neutral-300 hover:text-white dark:hover:text-white flex items-center "
                  href={item.href}
                >
                  <span className=" break-all">{item.label}</span>
                </a>
              ) : (
                <>
                  {item.label === globalJson.operating_time && (
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 35 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                    >
                      <mask
                        id="mask0_456_155"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="35"
                        height="35"
                      >
                        <rect
                          width="35"
                          height="35"
                          fill="url(#pattern0_456_155)"
                        />
                      </mask>
                      <g mask="url(#mask0_456_155)">
                        <rect
                          x="-19.5996"
                          y="-14.7"
                          width="79.1"
                          height="59.5"
                          fill="#1675D3"
                        />
                      </g>
                      <defs>
                        <pattern
                          id="pattern0_456_155"
                          patternContentUnits="objectBoundingBox"
                          width="1"
                          height="1"
                        >
                          <use
                            xlinkHref="#image0_456_155"
                            transform="scale(0.0078125)"
                          />
                        </pattern>
                        <image
                          id="image0_456_155"
                          width="128"
                          height="128"
                          xlinkHref="data:image/png;base64,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"
                        />
                      </defs>
                    </svg>
                  )}
                  {item.label === globalJson.phone && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 65 65"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_292_388)">
                        <path
                          d="M7.59237 2.16666C9.18102 0.577766 11.0224 -0.144455 13.1165 -7.62939e-06C15.2106 0.144432 16.9076 1.08332 18.2074 2.81666L25.5729 12.1333C26.2951 13 26.7644 13.975 26.9811 15.0583C27.1977 16.1417 27.1616 17.1889 26.8727 18.2L24.7064 27.0833C24.4176 28.0944 24.6342 28.9611 25.3563 29.6833L35.3214 39.65C36.0436 40.3722 36.9101 40.5889 37.921 40.3L46.803 38.1333C47.814 37.8444 48.861 37.8083 49.9442 38.025C51.0274 38.2417 52.0022 38.7111 52.8687 39.4333L62.184 46.8C63.917 48.1 64.8558 49.7972 65.0002 51.8917C65.1446 53.9861 64.4225 55.8278 62.8339 57.4167L58.7178 61.5333C57.1292 63.1222 55.2878 64.1694 53.1937 64.675C51.0996 65.1805 49.0416 65.0722 47.0196 64.35C36.188 60.5944 26.6922 54.6361 18.5324 46.475C10.3725 38.3139 4.41508 28.8167 0.660106 17.9833C-0.062005 15.9611 -0.170322 13.9028 0.335156 11.8083C0.840634 9.71388 1.8877 7.87222 3.47634 6.28333L7.59237 2.16666Z"
                          fill="#1675D3"
                        />
                      </g>
                    </svg>
                  )}
                  {item.label === globalJson.email && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 66 65"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_292_380)">
                        <path
                          d="M36.4098 1.73334C35.1098 1.15556 33.8098 0.866669 32.5098 0.866669C31.2098 0.866669 29.9098 1.15556 28.6098 1.73334L4.3431 14.7333C3.0431 15.4556 1.99588 16.4667 1.20143 17.7667C0.406988 19.0667 0.00976562 20.4389 0.00976562 21.8833V23.1833L27.3098 39.2167L32.5098 36.1833L37.7098 39.2167L65.0098 23.1833V21.8833C65.0098 20.4389 64.6125 19.0667 63.8181 17.7667C63.0237 16.4667 61.9764 15.4556 60.6764 14.7333L36.4098 1.73334ZM65.0098 27.95L41.8264 41.3833L65.0098 54.3833V27.95ZM64.7931 58.9333L32.5098 40.95L0.226432 58.9333C0.659766 60.6667 1.63477 62.1111 3.15143 63.2667C4.6681 64.4222 6.2931 65 8.02643 65H56.9931C58.7264 65 60.3514 64.4222 61.8681 63.2667C63.3848 62.1111 64.3598 60.6667 64.7931 58.9333ZM0.00976562 54.3833L23.1931 41.3833L0.00976562 27.95V54.3833Z"
                          fill="#1675D3"
                        />
                      </g>
                    </svg>
                  )}
                  {item.label === globalJson.address && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 49 66"
                      fill="none"
                    >
                      <path
                        d="M21.8359 63.8555C3.30078 37.1953 0 34.4023 0 24.5C0 11.043 10.791 0.125 24.375 0.125C37.832 0.125 48.75 11.043 48.75 24.5C48.75 34.4023 45.3223 37.1953 26.7871 63.8555C25.6445 65.6328 22.9785 65.6328 21.8359 63.8555ZM24.375 34.6562C29.9609 34.6562 34.5312 30.2129 34.5312 24.5C34.5312 18.9141 29.9609 14.3438 24.375 14.3438C18.6621 14.3438 14.2188 18.9141 14.2188 24.5C14.2188 30.2129 18.6621 34.6562 24.375 34.6562Z"
                        fill="#1675D3"
                      />
                    </svg>
                  )}

                  <span className="text-[#8A99B4] dark:text-neutral-300 break-words">
                    {item.label === globalJson.address
                      ? formatAddress(item.label)
                      : item.label}
                  </span>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="nc-Footer relative py-8 border-t border-neutral-200 dark:border-neutral-700 bg-[#121212]">
      <div className="container grid grid-cols-1 gap-y-10 gap-x-2  lg:grid-cols-4 py-12 ">
        <div className="grid grid-cols-1 gap-5 col-span-2 md:col-span-2 lg:col-span-1 lg:flex lg:flex-col">
          <h2 className="text-white font-bold">About Us</h2>
          <span className="text-[#8A99B4]">
            Delaware’s #1 Premier Choice for All Your Car Rental Needs We Strive
            and Promise to Provide the Top Leading Reliable and Affordable
            Rentals
          </span>

          <div className="hidden lg:flex  items-center gap-3">
            <a href="https://www.facebook.com/share/1BCe1fWb4m/?mibextid=wwXIfr">
              <svg
                width="45"
                height="45"
                viewBox="0 0 45 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="45" height="45" rx="22.5" fill="white" />
                <path
                  d="M26.2188 23.5H23.875V30.5H20.75V23.5H18.1875V20.625H20.75V18.4062C20.75 15.9062 22.25 14.5 24.5312 14.5C25.625 14.5 26.7812 14.7188 26.7812 14.7188V17.1875H25.5C24.25 17.1875 23.875 17.9375 23.875 18.75V20.625H26.6562L26.2188 23.5Z"
                  fill="#1675D3"
                />
              </svg>
            </a>
            <a href="https://www.instagram.com/bluediamond.enterprise/profilecard/?igsh=ZnNpM2t3Y2JrbDh2">
              <svg
                width="45"
                height="45"
                viewBox="0 0 45 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="45" height="45" rx="22.5" fill="white" />
                <path
                  d="M22.5 18.9062C24.4688 18.9062 26.0938 20.5312 26.0938 22.5C26.0938 24.5 24.4688 26.0938 22.5 26.0938C20.5 26.0938 18.9062 24.5 18.9062 22.5C18.9062 20.5312 20.5 18.9062 22.5 18.9062ZM22.5 24.8438C23.7812 24.8438 24.8125 23.8125 24.8125 22.5C24.8125 21.2188 23.7812 20.1875 22.5 20.1875C21.1875 20.1875 20.1562 21.2188 20.1562 22.5C20.1562 23.8125 21.2188 24.8438 22.5 24.8438ZM27.0625 18.7812C27.0625 19.25 26.6875 19.625 26.2188 19.625C25.75 19.625 25.375 19.25 25.375 18.7812C25.375 18.3125 25.75 17.9375 26.2188 17.9375C26.6875 17.9375 27.0625 18.3125 27.0625 18.7812ZM29.4375 19.625C29.5 20.7812 29.5 24.25 29.4375 25.4062C29.375 26.5312 29.125 27.5 28.3125 28.3438C27.5 29.1562 26.5 29.4062 25.375 29.4688C24.2188 29.5312 20.75 29.5312 19.5938 29.4688C18.4688 29.4062 17.5 29.1562 16.6562 28.3438C15.8438 27.5 15.5938 26.5312 15.5312 25.4062C15.4688 24.25 15.4688 20.7812 15.5312 19.625C15.5938 18.5 15.8438 17.5 16.6562 16.6875C17.5 15.875 18.4688 15.625 19.5938 15.5625C20.75 15.5 24.2188 15.5 25.375 15.5625C26.5 15.625 27.5 15.875 28.3125 16.6875C29.125 17.5 29.375 18.5 29.4375 19.625ZM27.9375 26.625C28.3125 25.7188 28.2188 23.5312 28.2188 22.5C28.2188 21.5 28.3125 19.3125 27.9375 18.375C27.6875 17.7812 27.2188 17.2812 26.625 17.0625C25.6875 16.6875 23.5 16.7812 22.5 16.7812C21.4688 16.7812 19.2812 16.6875 18.375 17.0625C17.75 17.3125 17.2812 17.7812 17.0312 18.375C16.6562 19.3125 16.75 21.5 16.75 22.5C16.75 23.5312 16.6562 25.7188 17.0312 26.625C17.2812 27.25 17.75 27.7188 18.375 27.9688C19.2812 28.3438 21.4688 28.25 22.5 28.25C23.5 28.25 25.6875 28.3438 26.625 27.9688C27.2188 27.7188 27.7188 27.25 27.9375 26.625Z"
                  fill="#1675D3"
                />
              </svg>
            </a>
            <a href="https://www.tiktok.com/@bluediamond.enterprise?_t=ZT-8ud63Z28mk7&_r=1">
              <svg
                width="45"
                height="45"
                viewBox="0 0 45 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <rect width="45" height="45" rx="22.5" fill="white" />
                <mask
                  id="mask0_322_156"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="14"
                  y="14"
                  width="16"
                  height="16"
                >
                  <rect
                    x="14"
                    y="14"
                    width="16"
                    height="16"
                    fill="url(#pattern0_322_156)"
                  />
                </mask>
                <g mask="url(#mask0_322_156)">
                  <rect x="9" y="8" width="32" height="30" fill="#1675D3" />
                </g>
                <defs>
                  <pattern
                    id="pattern0_322_156"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                  >
                    <use
                      xlinkHref="#image0_322_156"
                      transform="scale(0.0078125)"
                    />
                  </pattern>
                  <image
                    id="image0_322_156"
                    width="128"
                    height="128"
                    xlinkHref="data:image/png;base64,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"
                  />
                </defs>
              </svg>
            </a>
          </div>
        </div>
        {widgetMenus.map(renderWidgetMenuItem)}
        {/* <SocialsList1 className="lg:hidden flex items-start space-x-3 lg:flex-col lg:space-y-2.5 lg:items-start" /> */}
      </div>
    </div>
  );
};

export default Footer;
